import { render } from "./OptInV2.vue?vue&type=template&id=f4cdd468&scoped=true&ts=true"
import script from "./OptInV2.ts?vue&type=script&lang=ts&external"
export * from "./OptInV2.ts?vue&type=script&lang=ts&external"

import "./Optinv2.scss?vue&type=style&index=0&id=f4cdd468&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4cdd468"]])

export default __exports__